import AOS from 'aos';
import MobileNav from './mobile-nav';
import TeaserCarrousel from './teaser-carrousel';
import PostsList from './posts-list';
import KeyNumbers from './key-numbers';
import SubSectionScroll from './sub-section-scroll';
import Equipe from './equipe';
import ActiveToggle from './activeToggle';
import GoogleMaps from './googleMaps';
import Search from './search';
import IFrame from './iframe';
import Highlight from './highlight';
import Forms from './forms';

export default class View {
    constructor() {
        // animate on scroll library
        AOS.init({
            disable: false,
            startEvent: 'load',
            initClassName: 'aos-init',
            animatedClassName: 'aos-animate',
            useClassNames: false,
            disableMutationObserver: false,
            debounceDelay: 50,
            throttleDelay: 99,
            // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
            offset: 120,
            delay: 50,
            duration: 400,
            easing: 'ease',
            once: true,
            mirror: false,
            anchorPlacement: 'top-bottom',
        });

        window.addEventListener('load', () => {
            setTimeout(function () {
                AOS.refresh();
            }, 500);
        });
    }
    render() {
        const highlight = new Highlight();
        const mobileNav = new MobileNav();
        mobileNav.render();
        const teaserCarrousel = new TeaserCarrousel();
        teaserCarrousel.render();
        const postsList = new PostsList();
        postsList.render();
        const keyNumbers = new KeyNumbers();
        keyNumbers.render();
        const subSectionScroll = new SubSectionScroll();
        subSectionScroll.render();
        const equipe = new Equipe();
        equipe.render();
        const activeToggle = new ActiveToggle();
        activeToggle.render();
        // only execute google maps on contact page
        if (document.querySelector('body').classList.contains('contact')) {
            const googleMaps = new GoogleMaps();
            googleMaps.render();
        }
        const search = new Search();
        search.render();
        const iFrame = new IFrame();
        iFrame.render();
        const forms = new Forms();
        forms.render();
    }
}
